export default __webpack_public_path__ + "static/icon-coffee-coral-51e769266a8cdc8d2023882d68b8dab0.svg";